import { defineStore } from "pinia";
import { basicApi } from "@/services/api";
import type { IExposedOrder } from "@/models/responses/IExposedOrder";

export const useExposedOrderStore = defineStore("exposed-order", {
  state: () => ({
    error: "" as any,
    order: undefined as IExposedOrder | undefined,
  }),
  actions: {
    async fetch(id: number, orderToken: string) {
      this.error = "";
      this.order = undefined;
      await basicApi
        .get<IExposedOrder>(`v1.0/exposed-orders/${id}`, {
          headers: { "x-mel-ordertoken": orderToken },
        })
        .then((response) => (this.order = response.data))
        .catch((error) => (this.error = error));
    },
    async accept(id: number, deliveryDate: Date | undefined, orderToken: string, onfulfilled: () => void | PromiseLike<void>, onrejected: (reason: any) => void | PromiseLike<void>) {
      this.error = "";
      await basicApi
        .put(`v1.0/exposed-orders/${id}/accept`, {
          deliveryDate: deliveryDate
        }, {
          headers: { "x-mel-ordertoken": orderToken },
        })
        .then((response) => {
          this.order = response.data;
          onfulfilled();
        })
        .catch((error) => {
          this.error = error;
          onrejected(error);
        });
    },
  },
});
